import { Box, Flex, Text } from '@chakra-ui/react';

import { LightningIcon } from '~/features/experiments/ab_plp_redesign_2025/icons';

const FLASH_SALE_EYEBROW_LABEL = 'FLASH SALE';
const FLASH_SALE_EYEBROW_COLOR = '#AFC6FF';

export type FlashSaleEyebrowSize = 'default' | 'compact';

/**
 * Shared "FLASH SALE" eyebrow row (Figma 1672:3882 / 1672:3945): lightning icon + uppercase
 * condensed label + thin divider. Used by the 48/48 July promo homepage card and experience ATF card.
 */
export function FlashSaleEyebrow({ size = 'default' }: { size?: FlashSaleEyebrowSize }) {
  const isCompact = size === 'compact';
  return (
    <Flex alignItems='center' gap={isCompact ? 2 : 4} width='100%'>
      <Flex alignItems='center' color={FLASH_SALE_EYEBROW_COLOR} flexShrink={0} gap={2}>
        <LightningIcon height={isCompact ? '14px' : '16px'} width={isCompact ? '14px' : '16px'} />
        <Text
          fontFamily='condensed'
          fontSize={isCompact ? '12px' : '0.9375rem'}
          fontWeight='500'
          letterSpacing={isCompact ? '0.1em' : '0.06em'}
          lineHeight={1}
          textTransform='uppercase'
          whiteSpace='nowrap'
        >
          {FLASH_SALE_EYEBROW_LABEL}
        </Text>
      </Flex>
      <Box backgroundColor={FLASH_SALE_EYEBROW_COLOR} flex={1} height='1px' minWidth={0} opacity={0.6} />
    </Flex>
  );
}
